// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { info16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-info': IconInfo;
    }
}

/**
 * The icon component for the 'info' icon
 */
export class IconInfo extends IconSvg {
    public constructor() {
        super(info16X16);
    }
}

registerIconSvg('icon-info', IconInfo);
export const iconInfoTag = 'nimble-icon-info';
